"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPanelApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("./ApiBase");
const PopupRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/PopupRedux"));
class SettingsPanelApiImpl extends ApiBase_1.ApiBase {
    openSettingsPanel(moduleName) {
        const moduleInfo = this.adaptable.ModuleService.getModuleInfoByModule(moduleName);
        if (!moduleInfo) {
            this.logError(`${moduleName} module does not exist`);
            return;
        }
        this.dispatchAction(PopupRedux.PopupShowScreen(moduleName, moduleInfo.Popup));
    }
    openCustomSettingsPanel(name) {
        this.dispatchAction(PopupRedux.PopupShowScreen(null, name));
    }
}
exports.SettingsPanelApiImpl = SettingsPanelApiImpl;
